(function() { window.GUID_edbab3e5_bbc5_46d0_9ceb_8ffcaa8b79ac = { getGuid: function() { return "edbab3e5-bbc5-46d0-9ceb-8ffcaa8b79ac"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let LegalDocument;
        (function (LegalDocument) {
            LegalDocument[LegalDocument["PrivacyPolicy"] = 0] = "PrivacyPolicy";
            LegalDocument[LegalDocument["TermsOfService"] = 1] = "TermsOfService";
            LegalDocument[LegalDocument["SubscriptionTermsAndConditions"] = 2] = "SubscriptionTermsAndConditions";
        })(LegalDocument = Enumeration.LegalDocument || (Enumeration.LegalDocument = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=LegalDocument.pre.js.map
